module.exports = __webpack_public_path__ + "static/img/cpl.42174da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cpl.png
// module id = Ptbe
// module chunks = 1